import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-product-kind-list',
	templateUrl: './product-kind-list.component.html',
	styleUrls: ['./product-kind-list.component.css'],
})
export class ProductKindListComponent extends ListComponent {
	protected apiUrl = 'product/kind';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [{ id: 'name', name: 'Nazwa' }];

	protected convertData(data: any) {
		return data.results.map((item) => {
			item.id = '/description_requirement/' + item.id;
			return item;
		});
	}

	filters = {
		limit: 9999,
	};

	protected loadBefore(): void {
		this.bag.get('/codebook/1/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
